import { render, staticRenderFns } from "./systemMenu.vue?vue&type=template&id=851c6770&lang=true&"
import script from "./systemMenu.vue?vue&type=script&lang=js&"
export * from "./systemMenu.vue?vue&type=script&lang=js&"
import style0 from "./systemMenu.vue?vue&type=style&index=0&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "systemMenu.vue"
export default component.exports